import React from 'react';
import { History } from 'history';
import BaseCopy from '../base/base-copy.component'; 
import Model from './eventquiz-model';  //editable..

interface IProps { 
    history: History;
    caption?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class EventquizCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseCopy history={this.props.history} 
                endPointFilter={Model.endPointFilter} model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>                 
                
            </BaseCopy>
        );
    }
}